import { render, staticRenderFns } from "./addDepart.vue?vue&type=template&id=4a2d1182&scoped=true&"
import script from "./addDepart.vue?vue&type=script&lang=js&"
export * from "./addDepart.vue?vue&type=script&lang=js&"
import style0 from "./addDepart.vue?vue&type=style&index=0&id=4a2d1182&lang=scss&scoped=true&"
import style1 from "./addDepart.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2d1182",
  null
  
)

export default component.exports